/* eslint-disable */
// import {tokenAlive} from "@/Shared/jwtHelper";
import axios from 'axios'
const state = () => ({
    authData: {
        token: localStorage.getItem('access_token'),
        refreshToken: localStorage.getItem('refresh_token'),
        tokenExp: localStorage.getItem('tokenExp'),
        idToken: localStorage.getItem('idToken'),
        timenow: localStorage.getItem('tockentime'),
    },
    roledata: "",
    loginStatus: "",
});
const getters = {
    authenticated(state: { authData: { token: string | null; idToken: string | null; } }){
        return !!state.authData.token && !!state.authData.idToken;
      },
      getAccessToken(state: { authData: { token: string | null; } }){
        return state.authData.token;
      },
      getRolesData(state: { roledata: any }){
        return state.roledata;
      },
      getRefreshToken(state: { authData: { refreshToken: string | null; } }){
        return state.authData.refreshToken;
      },
      getIdToken(state: { authData: { idToken: string | null; } }){
        return state.authData.idToken;
      },
      isTokenActive(state: { authData: { token: string | null; idToken: string | null; tokenExp: string | number | null; timenow: string | null; }; }) {
        const token = state.authData.token;
        const idToken = state.authData.idToken;
        const tockentimethen = Number(state.authData.timenow);
        const tockenexptimes = Number(state.authData.tokenExp) * 1000;
        if (!token || !idToken || !Number.isFinite(tockentimethen) || !Number.isFinite(tockenexptimes) || tockenexptimes <= 0) {
            return false;
        }
        const diff = Date.now() - tockentimethen;
        // const expdiff = (state.authData.tokenExp) - diff;300
        // console.log("expiration time is " + tockenexptimes);
        const expdiff = tockenexptimes - diff;
        if (expdiff <= 0 ) {
            return false;
        }
        else{
            return true;
        }
        // return tokenAlive(state.authData.tokenExp);
    },
    getAuthData(state: { authData: any; }) {
        return state.authData
    }
};

const actions = {
    async loginuser({commit}: any, data: any) {
        // console.log(data);
        commit("setUser", data);
                  },
     async setroles({commit}: any, data: any) {
          commit("setrole", data);
                    },

    async setroledata({commit}: any, data: any) {
      const idToken = data.idtoken;
      if (!idToken) {
        commit('clearRoledata')
        return null
      }

      try {
        const res = await axios.get(
          `${process.env.VUE_APP_Service_URL}/account-core/user/getuserbytoken`,
          {
            headers: {
              Authorization: `Bearer ${idToken}`,
              'Content-Type': 'application/json',
            },
          }
        )

        if (res.data.roleId) {
          let rollidfromapi = res.data.roleId;
          commit('setrole', rollidfromapi);
        } else {
          commit('clearRoledata')
        }
      } catch (err) {
        console.error('Error loading role privileges:', err)
        commit('clearRoledata')
      }
    },
};

const mutations = {
    setUser(state: { user: any; authData: any }, userData: any){
        // console.log(userData.accessToken);
        const timenow = Date.now();
        state.authData = {
            token: userData.accessToken,
            refreshToken: userData.refreshToken,
            tokenExp: userData.expiresIn,
            idToken: userData.idToken,
            timenow: timenow,
        }
        // console.log(state.authData);
        if(userData != null || userData != ""){
        localStorage.setItem("access_token", userData.accessToken);
        localStorage.setItem("refresh_token", userData.refreshToken);
        localStorage.setItem("tokenExp", userData.expiresIn);
        localStorage.setItem("idToken", userData.idToken);
        localStorage.setItem("tockentime", timenow.toString());
      }
      },
      setrole(state: { roledata: any }, userroles: any){
          if(userroles){
        state.roledata = userroles;
          }
          else{
            state.roledata = "";
          }
      },
      clearRoledata(state) {
      state.roledata = null
    },
      clearAuthData(state: { authData: any }) {
      state.authData = {
        token: null,
        refreshToken: null,
        tokenExp: null,
        idToken: null,
        timenow: null,
      }
    },
};

export default {
    state,
    getters,
    actions,
    mutations
}
